import React, {useContext, useEffect, useState} from "react";
import UserContext from "../context/UserContext";
import DesktopViewContext from "../context/DesktopViewContext";
import { useNavigate } from "react-router-dom";
const CV = () => {
  const navigate = useNavigate();
  const {user} = useContext(UserContext);
  const {desktopView} = useContext(DesktopViewContext);
  const [licenseTypes, setLicenseTypes] = useState([]);
  const [additionalLicenses, setAdditionalLicenses] = useState([]);
  const [placeOfWork, setPlaceOfWork] = useState([]);
  const [employmentType, setEmploymentType] = useState([]);
  const [salaryDuration, setSalaryDuration] = useState([]);
  const [language, setLanguage] = useState([]);
  const [trailerType, setTrailerType] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [beginner, setBeginner] = useState([]);
  const [pav, setPav] = useState([]);

  const [skills, setSkills] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [salaryFrom, setSalaryFrom] = useState("");
  
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;

  useEffect(() => {
    const fetchJobInputs = async () => {
      try {
        const response = await fetch(api_endpoint + "/api/inputs");
        const fetchedData = await response.json();

        const initializeSelection = (items) =>
          items.map((item) => ({ ...item, selected: skills.includes(item.id) ? 1 : 0 }));

        setLicenseTypes(initializeSelection(fetchedData.license_type));
        setAdditionalLicenses(
          initializeSelection(fetchedData.additional_licenses)
        );
        setPlaceOfWork(initializeSelection(fetchedData.place_of_work));
        setEmploymentType(initializeSelection(fetchedData.employment_type));
        setSalaryDuration(initializeSelection(fetchedData.salary_duration));
        setLanguage(initializeSelection(fetchedData.language));
        setTrailerType(initializeSelection(fetchedData.trailer_type));
        setVehicle(initializeSelection(fetchedData.vehicle));
        setJobType(initializeSelection(fetchedData.job_type));
        setBeginner(initializeSelection(fetchedData.beginner));
        setPav(initializeSelection(fetchedData.pav));

      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };
    if (!isLoading) fetchJobInputs();
  }, [isLoading]);
  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const response = await fetch(`${api_endpoint}/api/users/myskills/${user.id}`);
        const fetchedSkills = await response.json();
        setSkills(fetchedSkills.skills);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching skills:", error);
      }
    };
    console.log(user)
    fetchSkills();
  }, [user]);
  const handleSelectionChange = (stateSetter, currentState, id) => {
    stateSetter(
      currentState.map((item) =>
        item.id === id
          ? { ...item, selected: item.selected === 0 ? 1 : 0 }
          : item
      )
    );

    const newSkills = skills.includes(id)
    ? skills.filter(skillId => skillId !== id)
    : [...skills, id];

  setSkills(newSkills);
  };
  const saveMySkills = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/users/myskills", {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          skills: skills,
          user: user
        })
      });      
      const res = await response.json();
      if (res) setSuccess(true);
      setTimeout(() => {
        handleBack();
      }, 2500);
    } catch (error) {
      console.error("Error sending my skills:", error);
    }
  };
  const handleBack = () => {
    navigate("/");
  }
  

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="job-apply-container">
      <h3>Saját képességeim és preferenciáim</h3>
      <div className="input-group">
  <label>Fizetés</label>
  <div className="salary-input-container">
    <input
      type="number"
      value={salaryFrom}
      onChange={(e) => setSalaryFrom(e.target.value)}
      placeholder="Elvárt minimum fizetés, ha van: írja be az összeget"
      min="0"
    />
  </div>
</div>

      <div className="job-inputs-container">
        <div>
          <h4>Segítség a képesítések kitöltéséhez</h4>
          <div className="multiselect">
            <div key={0} className={`multiselect-item`}>
              Nem rendelkezem a képesítéssel, vagy nem fontos számomra
            </div>
            <div key={1} className={`multiselect-item selected-orange`}>
              Rendelkezem a képesítéssel, vagy előnyben részesítem
            </div>
          </div>
        </div>
        {/* License Types Multi-Select */}
        <div className="input-group">
          <h4>Jogosítvány</h4>
          <div className="multiselect">
            {licenseTypes.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setLicenseTypes, licenseTypes, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* PAV Multi-Select */}
        <div className="input-group">
          <h4>PAV</h4>
          <div className="multiselect">
            {pav.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() => handleSelectionChange(setPav, pav, item.id)}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Additional Licenses Multi-Select */}
        <div className="input-group">
          <h4>Egyéb képesítések</h4>
          <div className="multiselect">
            {additionalLicenses.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(
                    setAdditionalLicenses,
                    additionalLicenses,
                    item.id
                  )
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Language Multi-Select */}
        <div className="input-group">
          <h4>Beszélt nyelvek</h4>
          <div className="multiselect">
            {language.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setLanguage, language, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Beginner Multi-Select */}
        <div className="input-group">
          <h4>Kezdő vagyok</h4>
          <div className="multiselect">
            {beginner.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setBeginner, beginner, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Place of Work Multi-Select */}
        <div className="input-group">
          <h4>Munkavégzés preferált helye</h4>
          <div className="multiselect">
            {placeOfWork.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setPlaceOfWork, placeOfWork, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Employment Type Multi-Select */}
        <div className="input-group">
          <h4>Munkavállalás preferált típusa</h4>
          <div className="multiselect">
            {employmentType.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(
                    setEmploymentType,
                    employmentType,
                    item.id
                  )
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

        {/* Salary Duration Multi-Select */}
        <div className="input-group">
          <h4>Preferált fizetési frekvencia</h4>
          <div className="multiselect">
            {salaryDuration.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(
                    setSalaryDuration,
                    salaryDuration,
                    item.id
                  )
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
        {/* Trailer Type Multi-Select */}
        <div className="input-group">
          <h4>Tréler tapasztalat vagy preferencia</h4>
          <div className="multiselect">
            {trailerType.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setTrailerType, trailerType, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

        {/* Vehicle Multi-Select */}
        <div className="input-group">
          <h4>Jármű tapasztalat vagy preferencia</h4>
          <div className="multiselect">
            {vehicle.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setVehicle, vehicle, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

        {/* Job Type Multi-Select */}
        <div className="input-group">
          <h4>Preferált munkatípus</h4>
          <div className="multiselect">
            {jobType.map((item) => (
              <div
                key={item.id}
                className={`multiselect-item ${
                  item.selected === 1
                    ? "selected-orange"
                    : ""
                }`}
                onClick={() =>
                  handleSelectionChange(setJobType, jobType, item.id)
                }
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

      </div>
      <div style={{minHeight:'10vh'}}></div>
      <div className={desktopView ? "footer-desktop" : "footer"}>
              <button
                className="back-button"
                onClick={handleBack}
              >
                Vissza a főoldalra
              </button>
              <button
                className="apply-button"
                onClick={saveMySkills}
              >
                {success ? "Sikeres  mentés" : "Önéletrajz mentése"}
              </button>
            </div>
    </div>
  );
};

export default CV;
